import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_CHECKLISTS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_CHECKLIST:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_CHECKLIST:
      return { ...state, [action.payload.Id]: action.payload };
    case type.IMPORT_CHECKLIST:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.EDIT_CHECKLIST:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_CHECKLIST:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
